import { render, staticRenderFns } from "./BatchResultManagerTableFilters.vue?vue&type=template&id=a56856de"
import script from "./BatchResultManagerTableFilters.vue?vue&type=script&lang=js"
export * from "./BatchResultManagerTableFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports